import PageHeader from "@/components/PageHeader";
import CTASection from "@/components/CTASection";
import { BUSINESS_AREAS } from "@/data/content";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

const Technologies = () => {
  useDocumentTitle("Technologies");
  return (
    <div data-testid="technologies-page">
      <PageHeader
        eyebrow="Technologies"
        title="A precision-engineered portfolio across science & industry."
        description="A vertically integrated technology portfolio spanning motors, AI, robotics, aviation, space sciences, and power."
        breadcrumb={[{ label: "Home", to: "/" }, { label: "Technologies" }]}
      />

      <section className="py-20 lg:py-24 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {BUSINESS_AREAS.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              className="group bg-white border border-slate-200 rounded-xl p-7 hover:shadow-lg hover:border-sky-300 transition-all"
            >
              <div className="w-11 h-11 rounded-md bg-[#0B1B3D]/5 border border-slate-200 flex items-center justify-center mb-5">
                <Icon className="w-5 h-5 text-[#0B1B3D]" strokeWidth={1.5} />
              </div>
              <h3 className="font-display text-lg font-semibold text-[#0B1B3D]">
                {title}
              </h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      <CTASection
        eyebrow="Custom Engineering"
        title="Need something specific? We engineer to order."
        description="Talk to us about custom motors, controllers, embedded devices or AI systems."
      />
      <div className="py-24" />
    </div>
  );
};

export default Technologies;
